import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/backend-modules`;

export const runBackendModuleAction = (action, payload) =>
  axios.post(
    `${API_PREFIX}/run`,
    { action, payload },
    { headers: getAuthHeaders() }
  );

export const extractBackendClaims = () =>
  axios.post(`${API_PREFIX}/extract-claims`, {}, { headers: getAuthHeaders() });
